







































import { defineComponent, PropType } from "@vue/composition-api";
import { Subject } from "@scrile/api-provider/dist/api/SubjectProvider";
import { TipSubjectType } from "@scrile/api-provider/dist/api/TipProvider";
import { UserWithAvatar } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { NotificationData } from "@/types";
import { EVENTS } from "@/const";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";
import BaseInput from "@/components/BaseInput";
import TipController from "@/components/TipController";
import { regexInput } from "@/components/TipController/const";

export default defineComponent({
  name: "GoalTipConfirm",
  components: { BaseInput, TipController, BaseButton, BaseConfirm },
  props: {
    show: { type: Boolean },
    user: { type: Object as PropType<UserWithAvatar>, required: true },
    goalId: { type: String, required: true },
  },
  setup(props, { emit }) {
    const subject: Subject<TipSubjectType> = { subjectId: props.goalId, subjectType: TipSubjectType.FUNDRAISING_GOAL };

    const onSuccess = () => {
      emitter.emit<NotificationData>(EVENTS.NOTIFICATION_SHOW, {
        text: $t("Thank you for donation!"),
        image: { user: props.user },
        position: "top",
      });
      emit("close");
    };

    return {
      subject,
      regexInput,
      onSuccess,
    };
  },
});
